export const EMPTY_AGG_RESPONSE_ERROR = 'Failed to fetch issue data from AGG, got empty data';
export const EMPTY_AGG_ISSUE_RESPONSE_ERROR =
	'Failed to fetch issue data from AGG, got empty issue value';
export const RETRIEVE_DATA_ERROR =
	'Failed to fetch issue data from AGG, got errorRetrievingData equals true';
